import { render, staticRenderFns } from "./SocialFooterIcons.vue?vue&type=template&id=33da74eb&"
import script from "./SocialFooterIcons.vue?vue&type=script&lang=js&"
export * from "./SocialFooterIcons.vue?vue&type=script&lang=js&"
import style0 from "./SocialFooterIcons.vue?vue&type=style&index=0&id=33da74eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports